var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.author)?_c('p',{staticClass:"ps-byline"},[_vm._v("\n  Last reviewed:\n  "),_c('time',{attrs:{"datetime":_vm.reviewedDate}},[_vm._v(_vm._s(_vm.reviewedLabel))]),_vm._v("\n  · "+_vm._s(_vm.author.name)+" · "+_vm._s(_vm.author.jobTitle)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }